module.exports = __webpack_public_path__ + "static/media/toilet.0d872418.png";